import { FundingModalFormValues } from 'core/widgets/funding-modal/FundingModal'
import SelectedPayPeriodsBrief from 'core/widgets/funding-modal/SelectedPayPeriodsBrief'
import useIndexedPayPeriods from 'core/widgets/funding-modal/useIndexedPayPeriods'
import { useMemo } from 'react'
import { useFormContext } from 'react-hook-form'
import { getSelectedPayPeriodsFromIds } from 'utils/Functions'

const useAmountBrief = () => {
  const { watch } = useFormContext<FundingModalFormValues>()
  const { indexedPayPeriods } = useIndexedPayPeriods()
  const [amountType, selectedPayPeriodIds] = watch([
    'amountType',
    'selected_pay_periods',
    'customAmount'
  ])

  const selectedPayPeriods = useMemo(
    () => getSelectedPayPeriodsFromIds(indexedPayPeriods, selectedPayPeriodIds),
    [selectedPayPeriodIds, indexedPayPeriods]
  )

  const selectedPayPeriodsBrief = useMemo(() => {
    return <SelectedPayPeriodsBrief selectedPayPeriods={selectedPayPeriods} />
  }, [selectedPayPeriods])

  const amountBrief = useMemo(() => {
    if (amountType === 'selected-pay-periods') {
      return selectedPayPeriodsBrief
    }
    if (amountType === 'all-pay-periods') {
      return <>All pay periods</>
    }
    return null
  }, [selectedPayPeriodsBrief, amountType])

  return amountBrief
}

export default useAmountBrief
